import WithGASetup from '../../components/WithGASetup';
import ConfirmationPage from './ConfirmationPage.js';

export default WithGASetup(ConfirmationPage);
